import { gql } from '@apollo/client'

import { ACTION_GENERATOR_STATS_FRAGMENT } from '@/graphql'

export const GET_ACTION_GENERATOR_STATS_SINGLE = gql`
  query GetActionGeneratorStatsSingle(
    $generatorId: ID!
    $filters: ActionGeneratorsInput!
  ) {
    actionGeneratorStatsSingle(generatorId: $generatorId, filters: $filters) {
      ...ActionGeneratorStats
    }
  }
  ${ACTION_GENERATOR_STATS_FRAGMENT}
`
